import { gql } from '@apollo/client'
import { AddressFragment } from '../fragments/address.fragments'

export const BestPracticeQuery = gql`
    query bestPracticeQuery($parentId: String!, $projectId: String!) {
        getBestPractice(parentId: $parentId, projectId: $projectId) {
            id
            firmId
            isGlobal
            parentProjectId
            projectElementNodeId
            contentItemId
            location {
                ...addressFragment
            }
            projectGroup
            parameters {
                selectedModifiers {
                    name
                }
                modifierList {
                    name
                }
            }
            isUserAddedContentBestPractice
        }
    }
    ${AddressFragment}
`

export const GetBestPracticesForContentQuery = gql`
    query getBestPracticesForContentQuery(
        $parentId: String!
        $projectId: String!
    ) {
        getBestPracticesForContent(parentId: $parentId, projectId: $projectId) {
            id
            firmId
            isGlobal
            parentProjectId
            projectElementNodeId
            contentItemId
            location {
                ...addressFragment
            }
            projectGroup
            parameters {
                selectedModifiers {
                    name
                }
                modifierList {
                    name
                }
            }
            isUserAddedContentBestPractice
            iterationId
            latestVersionId
        }
    }
    ${AddressFragment}
`

export const BestPracticeAuditHistoryQuery = gql`
    query bestPracticeAuditHistory(
        $iterationId: String
        $contentItemId: String
        $projectId: String
        $projectElementNodeId: String
    ) {
        getBestPracticeAuditHistory(
            iterationId: $iterationId
            contentItemId: $contentItemId
            projectId: $projectId
            projectElementNodeId: $projectElementNodeId
        ) {
            id
            action
            timestamp
            contentItemId
            appliedContentItemId
            bestPracticeId
            userId
            user {
                id
                email
                profileInfo {
                    firstName
                    lastName
                }
            }
            configuration {
                isGlobal
                projectGroup
                owner
                buildingType
                sustainabilityType
                contractType
                constructionType
                geographicRegion
                seismicZone
                windZone
                cityRegionCountry
            }
            changeDescription
            version {
                id
                timestamp
                modifiedBy
                isHidden
                elements {
                    id
                    text
                    type
                    placeholderText
                    imperialUnits
                    metricUnits
                    hyperlinkUrl
                    elements {
                        id
                        text
                        type
                        placeholderText
                        imperialUnits
                        metricUnits
                    }
                }
            }
        }
    }
`
